<template lang="pug">
    div
        loading-dialog(dialog :loading="loading")
        div
            v-stepper(v-model="step")
                v-stepper-header
                    v-stepper-step(
                        :complete="step > 1"
                        step="1"
                        :color="step > 1 ? 'green' : 'primary'"
                        ) Info. General
                    v-divider
                    v-stepper-step(
                        :complete="step > 2"
                        step="2"
                        :color="step > 2 ? 'green' : 'primary'"
                        ) Info. Comercial
                    v-divider
                    v-stepper-step(
                        :complete="step > 3"
                        step="3"
                        :color="step > 3 ? 'green' : 'primary'"
                        ) Info. Descuentos por cantidad.
                    v-divider
                    v-stepper-step(
                        :complete="step > 4"
                        step="4"
                        :color="step > 4 ? 'green' : 'primary'"
                        ) Info. Inventario
                v-stepper-items
                    v-stepper-content(step="1")
                        v-card
                            v-toolbar(dark='' color='white' flat)
                                v-spacer
                                v-btn(color="info" @click="generateInternalCode")
                                    | Generar Código Interno
                                    v-icon(right dark) refresh
                                v-btn(color="info" @click="generateUpc")
                                    | Generar UPC
                                    v-icon(right dark) refresh
                            commercial-info-step(
                                title="Información General"
                                step="2"
                                v-model="item" 
                                :fields="gFields"
                                @fields:change="gFields = $event"
                                @form:submit="createItem()"
                                @loading="loading = $event"
                                @step:next="step = 2"
                                confirmText="Crear"
                                ref="generalStep"
                                )
                    v-stepper-content(step="2")
                        v-card
                            commercial-info-step(
                                title="Información Comercial"
                                v-model="item.branch_office_data[0]" 
                                :fields="cFields"
                                @fields:change="cFields = $event"
                                @form:submit="updateItem(item, cFields)"
                                @step:prev="step = 1"
                                @step:next="step = 3"
                                @loading="loading = $event"
                                @form:reset="resetComercialForm(item)"
                                confirmText="Guardar"
                                ref="commercialStep"
                                )
                                    template(slot="prependContent")
                                        .section.mt-4.mx-5.pl-5.mb-5
                                            h2.title Información Sucursal 
                                            v-divider.mx-3
                                        v-autocomplete.mt-4.mr-4.ml-5.px-5(
                                                outline
                                                :items="officeList"
                                                item-text="name"
                                                item-value="id"
                                                label="sucursal"
                                                v-model="item.branch_office_data[0].g_branch_office_id"
                                                style="margin-bottom: -25px;"
                                                )
                                            template(slot="prepend")
                                                span.ml-3.formLabel Sucursal
                    v-stepper-content(step="3")
                        v-card
                            commercial-info-step(
                                title="Descuento Cantidad"
                                @form:submit="step = 4"
                                @step:prev="step = 2"
                                @step:next="step = 4"
                                @loading="loading = $event"
                                confirmText="Continuar"
                                ref="esquemaStep"
                            )
                                template(slot="prependContent").section.mt-4.mx-5.pl-5.mb-5
                                    h2.title Información Descuento Cantidad
                                    v-autocomplete.mt-4.mr-4.ml-5.px-5(
                                                outline
                                                :items="officeList"
                                                item-text="name"
                                                item-value="id"
                                                label="sucursal"
                                                v-model="item.branch_office_data[0].g_branch_office_id"
                                                style="margin-bottom: -25px;"
                                                )
                                    manage-whole-sale-discounts(
                                        submitText="Crear esquema" 
                                        crudOption="create"
                                        @clear-form="clearForm"
                                        @submit-form="submitFormSaleDiscount"
                                        @cancel-editing="returnPreviousRoute"
                                        hideBtnBack
                                    )
                    v-stepper-content(step="4")
                        v-card
                            commercial-info-step(
                                title="Información Inventario"
                                v-model="item" 
                                @input="test($event)"
                                :fields="iFields"
                                @fields:change="iFields = $event"
                                @form:submit="updateItem(item, iFields)"
                                @step:prev="step = 3"
                                @loading="loading = $event"
                                @step:finish="$router.push('/products')"
                                confirmText="Guardar"
                                v-bind="bindOptions"
                                ref="inventoryStep"
                                )
                                    template(slot="prependContent")
                                        .section.mt-4.mx-5.pl-5.mb-5
                                            h2.title Información Sucursal 
                                            v-divider.mx-3
                                        v-autocomplete.mt-4.mr-4.ml-5.px-5(
                                                outline
                                                :items="officeList"
                                                item-text="name"
                                                item-value="id"
                                                label="sucursal"
                                                v-model="item.branch_office_data[0].g_branch_office_id"
                                                style="margin-bottom: -25px;"
                                                )
                                            template(slot="prepend")
                                                span.ml-3.formLabel Sucursal
</template>

<script>
import { CommercialInfoStep, getFormatPartialData } from './steps'
import { fieldsGeneral, fieldsComercial, fieldsInventory } from './tabs'
import { LoadingDialog } from '@/components/reusable_components'
import { mapState, mapActions } from 'vuex'
/* services */
import BranchOfficeService from '@/services/api/branchOffice'
import FamilyService from '@/services/api/family/FamilyServices'
import ProductService from '@/services/api/product'
import TagService from '@/services/api/tag/TagServices'
import UPCService from '@/services/api/upc'
import UnitMeasurementService from '@/services/api/unitMeasurement/UnitMeasurementService'

import ManagerWholesaleDiscounts from '@/components/WholesaleDiscount/Manager'
import priceSchemeProduct from '../../services/api/priceScheme/priceSchemeProduct'
import SnackbarModalUtils from '@/mixins/reusable_mixins/SnackbarModalUtils'

export default {
    name: 'create-item-stepper',
    props: {},
    data: function() {
        return {
            step: 1,
            item: {
                branch_office_data: [
                    {
                        g_branch_office_id: 1,
                    },
                ],
            },
            gFields: fieldsGeneral,
            cFields: fieldsComercial,
            iFields: fieldsInventory,
            loading: false,
            // activeOfficeID: 1,
            officeList: [],
            showFinalizar: false,
        }
    },
    computed: {
        bindOptions: function() {
            if (this.showFinalizar) {
                return {
                    finishButton: 'Ir a listado de productos',
                }
            }
        },
        ...mapState('WholesaleDiscountModule', {
            arrayDiscounts: 'arrayDiscounts',
            id: 'id',
            globalPercentageDiscount: 'globalPercentageDiscount',
        }),
        ...mapState('AuthModule', ['user']),
    },
    methods: {
        /**
         * @description
         * Method for the first step. Creates the item on the database and handles the response
         */
        resetComercialForm: function(item) {
            let branchOffId = this.user.hr_employee.g_branch_office_id
            item.branch_office_data[0].g_branch_office_id = branchOffId
        },
        createItem: async function() {
            this.item.upc_codes = this.$refs.generalStep.$refs.stepForm.vmodels.upc_codes.flat()
            this.item.internal_code = this.$refs.generalStep.$refs.stepForm.vmodels.internal_code
            this.item.tags = this.$refs.generalStep.$refs.stepForm.vmodels.tags.flat()
            let data = this.getPropsByFields(this.item, this.gFields)
            this.loading = true
            let item = await ProductService.createItem(data)
            this.loading = false
            if (this.snackResponseSubmit(item, 'Producto creado')) {
                this.item = item
                this.setId(item.product_id)
                this.item.branch_office_data = [
                    {
                        g_branch_office_id: this.user.hr_employee
                            .g_branch_office_id,
                    },
                ]
                this.step = 2
                return
            }
        },
        formatPartialData: getFormatPartialData(this),
        updateItem: async function(item = this.item, fields, parse = false) {
            let data = parse
                ? this.getPropsByFields(this.item, fields)
                : this.item
            /* jano work */
            console.log(data, 'update iten ')
            console.log(
                this.$refs.inventoryStep.$refs.stepForm.vmodels,
                'vmodels'
            )
            /* jano end */

            if (data.branch_office_data)
                data.branch_office_data = data.branch_office_data.map(o => {
                    o.cost_price = parseFloat(o.cost_price)
                    return o
                })

            data = this.formatPartialData(data)
            data.is_consumable =
                this.$refs.commercialStep.$refs.stepForm.vmodels
                    .is_consumable == ''
                    ? false
                    : this.$refs.commercialStep.$refs.stepForm.vmodels
                          .is_consumable
            data.is_salable =
                this.$refs.commercialStep.$refs.stepForm.vmodels.is_salable ==
                ''
                    ? false
                    : this.$refs.commercialStep.$refs.stepForm.vmodels
                          .is_salable
            data.is_tax_free =
                this.$refs.commercialStep.$refs.stepForm.vmodels.is_tax_free ==
                ''
                    ? false
                    : this.$refs.commercialStep.$refs.stepForm.vmodels
                          .is_tax_free
            data.is_seasonal =
                this.$refs.inventoryStep.$refs.stepForm.vmodels.is_seasonal ==
                ''
                    ? false
                    : this.$refs.inventoryStep.$refs.stepForm.vmodels
                          .is_seasonal
            data.is_inventoriable =
                this.$refs.inventoryStep.$refs.stepForm.vmodels
                    .is_inventoriable == ''
                    ? false
                    : this.$refs.inventoryStep.$refs.stepForm.vmodels
                          .is_inventoriable
            data.have_decimal_quantity =
                this.$refs.inventoryStep.$refs.stepForm.vmodels
                    .have_decimal_quantity == ''
                    ? false
                    : this.$refs.inventoryStep.$refs.stepForm.vmodels
                          .have_decimal_quantity
            data.is_repackaged =
                this.$refs.inventoryStep.$refs.stepForm.vmodels.is_repackaged ==
                ''
                    ? false
                    : this.$refs.inventoryStep.$refs.stepForm.vmodels
                          .is_repackaged
            data.uom_quantity =
                this.$refs.inventoryStep.$refs.stepForm.vmodels.uom_quantity ==
                ''
                    ? 1
                    : this.$refs.inventoryStep.$refs.stepForm.vmodels
                          .uom_quantity
            data.wh_unit_of_measurement_id =
                this.$refs.inventoryStep.$refs.stepForm.vmodels
                    .wh_unit_of_measurement_id == ''
                    ? 1
                    : this.$refs.inventoryStep.$refs.stepForm.vmodels
                          .wh_unit_of_measurement_id

            this.loading = true
            let response = await ProductService.updateItem(
                this.item.product_id,
                data
            )
            console.log(response, 'response testing')

            if (this.snackResponseSubmit(response, 'Producto Editado')) {
                this.loading = false

                //this.step = 3
                if (this.step === 2) {
                    this.step = 3
                } else if (this.step === 3) {
                    this.step = 4
                } else if (this.step === 4) {
                    this.step = 4
                    this.showFinalizarButton()
                }
            }

            return
        },
        test(e) {
            console.log('test', e)
        },
        /**
         * @description
         */
        getPropsByFields: function(item, fields) {
            return fields.reduce((obj, field) => {
                obj[field.field] = item[field.field]
                return obj
            }, {})
        },
        async showSnackbar(
            type,
            title,
            message,
            progress = false,
            time = 3000,
            callback = () => {}
        ) {
            this.resetSnackbarState()
            this.initSnackbar(
                this.fillSnack(type, title, message, progress, time)
            )
            callback()
        },
        async generateUpc() {
            this.showSnackbar('info', 'Generando Código', '', true, null)
            let resp = await UPCService.generateUpc()
            const upc = resp.suggested_code
            this.fillUpcField(upc)
            this.resetSnackbarState()
        },
        async generateInternalCode() {
            this.showSnackbar('info', 'Generando Código', '', true, null)
            let dataSubmit = this.getDataForSuggestInternalCode()
            let resp = await ProductService.suggestInternalCode(dataSubmit)
            if (this.snackResponseSubmit(resp, 'Código generado')) {
                this.fillInternalCodeField(resp.suggested_code)
            }
        },
        fillUpcField(upc) {
            let auxFields = this.$refs.generalStep.$refs.stepForm.vmodels
            let setFields = [...this.gFields]
            //
            console.log({ auxFields, setFields })
            //set UPC
            if (setFields[5].value.length > 0)
                setFields[5].value = [parseInt(upc), ...auxFields.upc_codes]
            else setFields[5].value = [parseInt(upc)]
            // copy values other fields
            setFields[0].value = auxFields.name
            setFields[1].value = auxFields.alias_name
            setFields[2].value = auxFields.description
            setFields[3].value = auxFields.wh_family_id
            setFields[4].value = auxFields.wh_subfamily_id
            setFields[6].value = auxFields.internal_code
            setFields[7].value = [...auxFields.tags]
            //
            this.gFields = [...setFields]
        },
        fillInternalCodeField(suggestedCode) {
            let auxFields = this.$refs.generalStep.$refs.stepForm.vmodels
            let setFields = [...this.gFields]
            //set InternalCode
            setFields[6].value = suggestedCode
            // copy values other fields
            setFields[0].value = auxFields.name
            setFields[1].value = auxFields.alias_name
            setFields[2].value = auxFields.description
            setFields[3].value = auxFields.wh_family_id
            setFields[4].value = auxFields.wh_subfamily_id
            setFields[5].value =
                auxFields.upc_codes.length > 0 ? [...auxFields.upc_codes] : []
            setFields[7].value = [...auxFields.tags]
            //
            this.gFields = [...setFields]
        },
        setShowFinalizarButton(val) {
            this.showFinalizar = val
        },
        showFinalizarButton() {
            //pregunto si vengo del mismo step, ya q esto me indica si guarde o no
            if (this.step == 4) {
                this.setShowFinalizarButton(true)
            }
        },
        getDataForSuggestInternalCode() {
            let generalForm = this.$refs.generalStep.$refs.stepForm.vmodels
            let dataSubmit = {}
            dataSubmit.name = generalForm.name
            dataSubmit.wh_family_id = generalForm.wh_family_id
            dataSubmit.wh_subfamily_id = generalForm.wh_subfamily_id
            return dataSubmit
        },
        async submitFormSaleDiscount() {
            console.log(this.arrayDiscounts, 'arraydiscount')
            let discountSchema = this.arrayDiscounts.map(arr => {
                let newObj = {}
                newObj.quantity_discount = arr.quantity
                newObj.percentage_discount = arr.discount
                newObj.unit_price_discount = 0
                return newObj
            })
            //
            let data = {}
            data.wh_product_id = this.id
            data.g_branch_office_id = this.user.hr_employee.g_branch_office_id
            // this.item.branch_office_data[0].g_branch_office_id
            data.discount_schema = discountSchema

            let response = await priceSchemeProduct(data)
            if (response.status === 'success') {
                this.showSnackbar(
                    'success',
                    'Éxito',
                    'Descuento Cantidad creado Exitosamente'
                )
                this.step = 4
            } else {
                this.showSnackbar('error', 'Error', response.message)
            }
        },
        /* vuex */
        ...mapActions('SnackbarModalModule', {
            initSnackbar: 'initSnackbar',
            resetSnackbarState: 'resetSnackbarState',
            setMessageConfirmSnack: 'setMessageConfirmSnack',
        }),
        ...mapActions('MenuesModule', {
            setTitleTopBar: 'setTitleTopBar',
        }),
        /*
         */
        ...mapActions('WholesaleDiscountModule', {
            resetArrayDiscounts: 'resetArrayDiscounts',
            addDiscount: 'addDiscount',
            resetStateWholesaleDiscount: 'resetState',
            setGlobalPercentageDiscount: 'setGlobalPercentageDiscount',
            setId: 'setId',
            setMaxPriceDiscount: 'setMaxPriceDiscount',
            restartEditing: 'restartEditing',
        }),
    },
    watch: {
        item: {
            handler: function(oldVal, newVal) {
                if (oldVal.id !== newVal.id && step > 1)
                    this.item.id = oldVal.id
            },
            deep: true,
        },
    },
    components: {
        'loading-dialog': LoadingDialog,
        'commercial-info-step': CommercialInfoStep,
        'manage-whole-sale-discounts': ManagerWholesaleDiscounts,
    },
    mixins: [SnackbarModalUtils],
    filters: {},
    // Lifecycle Methods
    //
    // beforeCreate: function(){...},
    created: async function() {
        this.setTitleTopBar('Crear Producto')
        this.loading = true
        this.gFields[3].options.data = await FamilyService.fetchAllFamily()
        this.gFields[7].options.data = await TagService.fetchAllTags()
        this.officeList = await BranchOfficeService.fetchAll()
        this.iFields[3].options.data = await UnitMeasurementService.fetchAll()
        this.loading = false
        this.setGlobalPercentageDiscount(true)
        // this.addDiscount()
        // this.setId(id)
        this.setMaxPriceDiscount(100)
    },
    beforeRouteEnter(to, from, next) {
        next(ctx => {
            if (!ctx.$can('CREATE_PRODUCT_ITEM')) ctx.$router.push('/')
        })
    },
    // mounted: function(){...},
    // beforeUpdate: function(){...},
    // updated: function(){...},
    // beforeDestroy: function(){...},
    // destroyed: function(){...},
    //
    // End Lifecycle Methods
}
</script>

<style lang="scss" scoped>
.formLabel {
    font-weight: bold;
    min-width: 150px;
    max-width: 150px;
    font-size: 20px;
}
.section {
    display: flex;
    flex-direction: row;
    align-items: center;
}
</style>
